exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-invalid[data-v-64ee0390] {\n  border: 1px solid red !important;\n  border-radius: 4px;\n}\n.truncate[data-v-64ee0390] {\n  display: inline-block;\n  max-width: 150px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n#custom-table[data-v-64ee0390] {\n  font-family: none;\n}\n", ""]);

// exports
